import { css } from '@emotion/react';
import { useState } from 'react';
import { breakpoints, colors, spacing } from '../../../utils/styleguide';
import Typography from '../text/Typography';

const SUBMIT_URL = 'https://cxzibguyzc.execute-api.eu-west-1.amazonaws.com/production/signup';

function reportSuccessEvent() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'formSubmissionSuccess',
    formId: 'signup-form',
  });
}

const SignUpForm = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState<string>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      const response = await fetch(SUBMIT_URL, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.status === 409) {
        return setMessage('Nice try! 😎 This email is already on the early access list.');
      }
      if (response.status > 299) {
        return setMessage('Opos! Something went wrong in the signup, try again later.');
      }

      setMessage('Thank you! We’ll let you know when it’s time to get on the wire. 🙌');
      reportSuccessEvent();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
  return (
    <div
      css={css`
        max-width: 500px;
        margin: auto;
        ${breakpoints.desktop} {
          max-width: initial;
          display: flex;
        }
      `}
    >
      <Typography
        useBuiltInMargins
        variant="heroTitle"
        tag="h2"
        css={css`
          ${breakpoints.desktop} {
            flex-basis: 60%;
            flex-shrink: 0;
            margin: 0;
          }
        `}
      >
        Sign up for early access
      </Typography>
      <div
        css={css`
          ${breakpoints.desktop} {
            margin-left: ${spacing[3]}px;
            display: flex;
            align-items: center;
            flex-basis: 40%;
          }
        `}
      >
        {message ? (
          <Typography useBuiltInMargins>{message}</Typography>
        ) : (
          <form onSubmit={handleSubmit} css={css``}>
            <Typography useBuiltInMargins tag="label" css={css``}>
              Milkywire is a new social crowdfunding platform making charity easy and fun. Get the
              app and be among the first to join!
            </Typography>
            <div
              css={css`
                display: flex;
                flex-direction: column;
                align-items: center;
                ${breakpoints.desktop} {
                  flex-direction: row;
                  margin-top: ${spacing[3]}px;
                }
              `}
            >
              <input
                type="text"
                value={email}
                onChange={handleChange}
                placeholder="name@email.com"
                aria-label="Email"
                css={css`
                  box-sizing: border-box;
                  height: 56px;
                  font-family: Sharp-Grotesk;
                  padding: 0 ${spacing[3]}px;
                  border: 1px solid ${colors.grey};
                  width: 100%;
                  margin-top: ${spacing[5]}px;
                  text-align: center;
                  ${breakpoints.desktop} {
                    margin-top: 0;
                    width: initial;
                    flex-basis: 60%;
                    text-align: initial;
                  }
                `}
              />
              <Typography
                useBuiltInMargins
                variant="buttonLarge"
                tag="input"
                type="submit"
                value="Sign up"
                css={css`
                  box-sizing: border-box;
                  background-color: ${colors.black};
                  height: 56px;
                  width: 200px;
                  border-radius: 100px;
                  border: none;
                  color: white;
                  margin-top: ${spacing[3]}px;
                  ${breakpoints.desktop} {
                    margin-top: 0;
                    margin-left: ${spacing[3]}px;
                    width: initial;
                    flex: 1;
                    padding: 0 ${spacing[3]}px;
                  }
                `}
              />
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default SignUpForm;
